import { IBigQueryStepChartedTreatment } from '../dimensions/treatment-step';
import { ITreatmentStepEventFact } from './treatment-step-event';

export interface IAppointmentTreatmentEvent extends ITreatmentStepEventFact {
  treatment: IBigQueryStepChartedTreatment;
}
